<script setup lang="ts">

	import AlertBar from '@/components/AlertBar.vue';
	import ShoppingcartOrderWeek from '@/components/ShoppingcartOrderWeek.vue';
	import type {DeliveryDate} from 'dummen-shared';
	import {useI18n} from 'vue-i18n';
	import {type ShoppingCartOrderLine} from 'dummen-shared/src/interfaces/order.line.type.ts';

	const emit = defineEmits(['on-close-shopping-cart', 'on-toggle-shopping-cart']);

	const props = defineProps<{
		deliveryWeeks: Map<string, ShoppingCartOrderLine[]>;
		deliveryDates: DeliveryDate[];
		showOrdersWithAvailabilityIssues: boolean;
	}>();

	const {t} = useI18n();

	const agreedToTermsAndConditions = window.agreedToTermsAndConditions;

	const closeShoppingCart = () => emit('on-close-shopping-cart');

	const toggleShoppingCart = () => emit('on-toggle-shopping-cart');

	const getTermsAndConditionsUrl = () => {
		const pathname = location.pathname;
		const language = pathname.split('/')[2];

		return `/app/${language}/my#/terms-and-conditions`;
	};

	const goToTermsAndConditions = () => {
		if (!location.pathname.includes('terms-and-conditions')) {
			location.replace(getTermsAndConditionsUrl());
		}

		toggleShoppingCart();
	};

</script>

<template>
	<div class="shoppingcart-content">
		<div class="shoppingcart-header shoppingcart-header__message">
			<div class="shoppingcart-row create-po-message">
				{{ t('shoppingcart.disclaimer.text') }}
			</div>
		</div>

		<div v-if="!deliveryDates.length" class="shoppingcart-row">
			<h5>
				{{ t('shoppingcart.empty.text') }}
			</h5>
		</div>

		<template v-else>
			<div v-if="!agreedToTermsAndConditions"
			     key="termsandconditions-status"
			     class="shoppingcart-row" style="margin-top: 2rem;">

				<alert-bar>
					<span>{{ t('shoppingcart.user.notAgreedToTermsAndCondtions.text') }}</span>

					<template v-slot:action>
						<a href="#" @click.prevent="goToTermsAndConditions">
							{{ t('shoppingcart.user.goToTermsAndCondtions.text') }}</a>
					</template>
				</alert-bar>
			</div>

			<div class="shoppingcart-orders-wrapper">
				<TransitionGroup name="fade-remove">
					<shoppingcart-order-week v-for="[weekYear, orderLines] in deliveryWeeks"
					                         :key="weekYear"
					                         :week="Number.parseInt(weekYear.split('-')[0])"
					                         :year="Number.parseInt(weekYear.split('-')[1])"
					                         :orderLines="orderLines"
					                         @close-shopping-cart="closeShoppingCart"
					                         :show-orders-with-availability-issues="props.showOrdersWithAvailabilityIssues"
					/>
				</TransitionGroup>
			</div>
		</template>
	</div>
</template>
